import { getFetchUrl } from './get-fetch-url';
/**
 * @internal
 */
export var getFetchManySubEntitiesUrl = function (entityIds, subEntityType, productType, includeType) {
    return getFetchUrl(entityIds, productType, includeType, subEntityType);
};
